// external js: isotope.pkgd.min.js

// init Isotope
jQuery(function ($) {
	var $grid = $('.isotope').isotope({
		//Isotope options
		//'item' matches the class in the post loop
		itemSelector: '.grid-item',
		// set layoutMode
		// options for layout mode
		masonry: {
			// columnWidth: 410,
			gutter: 10,
			transitionDuration: '0.4s',
		},
		filter: '.featured', // sets initial filter
	});

	// store filter for each group
	var filters = {};

	$('.filters').on('click', '.button', function (event) {
		var $button = $(event.currentTarget);
		// get group key
		var $buttonGroup = $button.parents('.button-group');
		var filterGroup = $buttonGroup.attr('data-filter-group');
		// set filter for group
		filters[filterGroup] = $button.attr('data-filter');
		// combine filters
		var filterValue = concatValues(filters);
		// set filter for Isotope
		$grid.isotope({ filter: filterValue });

		// scroll to top of Isotope when filters buttons are clicked – good for Mobile specifically
		let isoTop = $('#isotope-list').offset().top + -200;
		window.scrollTo(0, isoTop);
	});

	// change is-checked class on buttons
	$('.button-group').each(function (i, buttonGroup) {
		var $buttonGroup = $(buttonGroup);
		$buttonGroup.on('click', 'button', function (event) {
			$buttonGroup.find('.selected').removeClass('selected');
			var $button = $(event.currentTarget);
			$button.addClass('selected');
		});
	});

	// flatten object by concatting values
	function concatValues(obj) {
		var value = '';
		for (var prop in obj) {
			value += obj[prop];
		}
		return value;
	}

	// show error message if no filter results
	$grid.on('arrangeComplete', function (event, filteredItems) {
		if (filteredItems.length > 0) {
			$('#no_results').css('opacity', '0');
		} else {
			$('#no_results').css('opacity', '1');
		}
	});

	//****************************
	// Isotope load more button
	//****************************
	var initShow = 5; // number of items loaded on init & onclick load more button
	var counter = initShow; // counter for load more button
	var iso = $grid.data('isotope'); // get Isotope instance

	loadMore(initShow); // execute function onload

	function loadMore(toShow) {
		$grid.find('.iso_hidden').removeClass('iso_hidden');

		var hiddenElems = iso.filteredItems
			.slice(toShow, iso.filteredItems.length)
			.map(function (item) {
				return item.element;
			});
		$(hiddenElems).addClass('iso_hidden');

		$grid.isotope('layout');

		// when no more to load, hide show more button
		if (hiddenElems.length == 0) {
			jQuery('#iso_load_more').hide();
		} else {
			jQuery('#iso_load_more').show();
		}
	}

	// append load more button
	$grid.after(
		'<button class="arrow_button btn center_align" id="iso_load_more" style="z-index: 0;">Load more projects</button>'
	);

	// when load more button clicked
	$('#iso_load_more').click(function () {
		if ($('.filters').data('clicked')) {
			// when filter button clicked, set initial value for counter
			counter = initShow;
			$('.filters').data('clicked', false);
		} else {
			counter = counter;
		}

		// $('#isotope-list').isotope('reLayout');
		counter = counter + initShow;
		loadMore(counter);
	});

	// making load more keyboard accessible
	$('#iso_load_more').on('keydown', function (e) {
		// find first hidden element with .iso_hidden applied
		var firstFocus = $('.isotope').children('.iso_hidden')[0];

		// :focus first loaded result
		setTimeout(function () {
			$(firstFocus).find('h3 > a.loadmore_focus').focus();
		}, 500);
	});

	// when filter button clicked
	$('.filters').click(function () {
		$(this).data('clicked', true);

		loadMore(initShow);
	});
});
